import { useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [resetLink, setResetLink] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setResetLink("");

    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      setMessage(data.message || "Permintaan reset password diproses.");

      if (data.token) {
        setResetLink(`${window.location.origin}/reset-password?token=${data.token}`);
      }
    } catch {
      setMessage("Terjadi kesalahan. Silakan coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow">
        <h1 className="text-2xl font-bold">Lupa Password</h1>

        <p className="mt-2 text-zinc-500">
          Masukkan email untuk mendapatkan link reset password.
        </p>

        <form onSubmit={handleSubmit} className="mt-6">
          <label className="mb-2 block text-sm font-medium">
            Email
          </label>

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full rounded-lg border px-3 py-2"
            placeholder="email@contoh.com"
          />

          <button
            type="submit"
            disabled={loading}
            className="mt-4 w-full rounded-lg bg-black py-2 text-white"
          >
            {loading ? "Memproses..." : "Kirim Link Reset"}
          </button>
        </form>

        {message && (
          <p className="mt-4 text-sm text-zinc-600">
            {message}
          </p>
        )}

        {resetLink && (
          <div className="mt-4 rounded-lg bg-zinc-100 p-3">
            <p className="text-xs text-zinc-500 mb-2">
              Link reset:
            </p>

            <a
              href={resetLink}
              className="break-all text-sm underline"
            >
              {resetLink}
            </a>
          </div>
        )}

        <Link
          to="/login"
          className="mt-4 block text-center text-sm text-zinc-500 hover:text-zinc-900"
        >
          Kembali ke Login
        </Link>
      </div>
    </div>
  );
}
